module.exports = __webpack_public_path__ + "img/11.891c9c4e.jpg";